import { useState } from "react";
import { dispatch, getState } from "../../state/store";
import { selectFwuCampaignToEdit } from "../../state/selectors";
import { setFWUCampaignToEdit, setFwuCampaingsRefresh } from "../../state/ducks";

import { campaignStatus, strCode } from "../../consts";
import { fwuCampaignsService, log, notificationService, t } from "../../services";
import { responseUtil } from "../../utils";

export const useDeactivateFWUCampaign = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  // TODO: temporary hotfix
  const refreshFWUCampaignToEdit = () => {
    const fwuCampaignToEdit = selectFwuCampaignToEdit()(getState());

    if (fwuCampaignToEdit) {
      fwuCampaignToEdit.status = campaignStatus.inactive;

      dispatch(setFWUCampaignToEdit(fwuCampaignToEdit));
    }
  };

  const mutationCallback = async (campaignName) => {
    setLoading(true);
    setError(false);

    try {
      const res = await fwuCampaignsService.deactivateFWUCampaign(campaignName);

      if (responseUtil.isResponseSuccessful(res)) {
        notificationService.showSuccess({
          title: t(strCode.DEACTIVATE_FWU_CAMPAIGN_SUCCESS),
          message: t(strCode.DEACTIVATE_FWU_CAMPAIGN_SUCCESS_INFO, {
            name: campaignName
          })
        });

        refreshFWUCampaignToEdit();
        dispatch(setFwuCampaingsRefresh(true));
      }
    } catch (err) {
      setError(true);

      log.error("useDeactivateFWUCampaign: Failed to deactivate FWU campaign", err);

      notificationService.showError({
        title: t(strCode.DEACTIVATE_FWU_CAMPAIGN_ERROR),
        message: err?.response?.data ? err.response.data : err?.toString()
      });
    } finally {
      setLoading(false);
    }
  };

  return { mutationCallback, loading, error };
};
